module.exports = __webpack_public_path__ + "static/media/OrlandoDist.7cb729b1.PNG";